import DocumentTemplate from '@/components/ui/document-template/DocumentTemplate'
import { PropsWithChildren } from 'react'

function Section({ children }: PropsWithChildren) {
	return <section className="flex flex-col gap-5">{children}</section>
}

function EmailLink() {
	return (
		<a href="mailto:peppercoin.dpo@marcellocarames.com" className="underline" target="_blank">
			peppercoin.dpo@marcellocarames.com
		</a>
	)
}

const CONTENT = [
	{
		title: '1. Parties',
		text: (
			<Section>
				<p>
					1.1 This Privacy Notice describes how Entertainment Trading Technologies Limited (or otherwise
					referred to herein as “Peppercoin”, ”Company”, "Us" or "We") treats your personal information and
					the data provided to us in order to be able to manage our relationship. We manage any personal
					information You could provide to Us either through the website: https://www.peppercoin.com/ and/or
					via the Peppercoin Mobile Application (hereinafter referred to as 'this Website/App' or 'the
					Website/App' and are kept by Us in relation to You in the manner specified in this Privacy Policy.
					<br />
					<br />
					As it is specified in our Terms and Conditions, the primary function of the Peppercoin Interface,
					among others, is to facilitate access to decentralized finance (DeFi) operations (hereinafter
					referred to as 'the Service'). It is important to note that Peppercoin provides only the interface
					and software tools; it does not exercise control over your blockchain interactions neither We do not
					provide financial, legal, or tax advice, and should not be considered as doing so.
				</p>
				<p>
					1.2 All natural persons or other subjects who log onto this Website/App shall be users of this
					Website/App. For the convenience of wording in this Policy, the users or visitors are referred to as
					'You' or any other applicable forms of the second-person pronouns.
				</p>
				<p>
					1.3 For the convenience of wording in this Policy, You and We are collectively referred to as “both
					parties,” and individually as “one party.”
				</p>
				<p>
					1.4 We take our responsibilities under the Constitution of Seychelles and Seychelles’ Data
					Protection Act No.19 of 2023 (the “DPA”) seriously. We also recognize the importance of the personal
					data You have entrusted to Us and believe that it is our responsibility to properly manage, protect
					and process your personal data.
				</p>
			</Section>
		)
	},
	{
		title: '2. Who Are We',
		text: (
			<span>
				We are Entertainment Trading Technologies Limited, a Company registered in the Republic of Seychelles
				with company registration number 218014, whose registered address is at Suite 202, 2nd Floor, Eden
				Plaza, Eden Island, Make, Republic of Seychelles. We have appointed an European Representative, who may
				be contacted at <EmailLink />.
			</span>
		)
	},
	{
		title: '3. Purposes of the Privacy Policy',
		text: (
			<Section>
				<p>
					This Privacy Policy stipulates the types of information that We may collect through visiting this
					Website/App, your interaction with this Website/App and/or use the Services we could offer at some
					point in time, as well as how We shall use and protect the information collected or You provide Us,
					in case. If You are in the European Union, the European General Data Protection Regulation (GDPR, EU
					976/2016) applies.
					<br />
					<br />
					To ensure that You have full confidence in our handling of personal data, You are advised to read
					and understand the terms of this Privacy Policy in detail. In particular, upon your access to our
					Website/App and/or use the Services that We could offer You shall be deemed to accept, undertake and
					confirm that:
				</p>
				<p>
					3.1 You, on the basis of your own free will, agree to disclose and share your personal information
					to Us;
				</p>
				<p>3.2 You will comply with all the terms of this Privacy Policy;</p>
				<p>
					3.3 You agree that We may collect your information through your access to this Website/App and/or
					using the Services offered by Us at some stage; You agree to any changes and modifications that We
					may make to our Privacy Policy in the future;{' '}
				</p>
				<p>
					3.4 You agree that our branches, affiliates and employees may contact You in connection with the
					products and services that We can offer or You could be interested in (unless You have indicated
					that You do not want to receive such information).
				</p>
			</Section>
		)
	},
	{
		title: '4. Information Collected',
		text: (
			<Section>
				<p>
					4.1 When You use this Website/App, You agree to permit Us and our third-parties to use cookies and
					other tracking technologies to provide and personalize the Services and features of the Services for
					you across sessions or learn about your preferences or your use of the Services or our interactions
					with You. We will only collect your personal data in accordance with the legislative purpose of the
					DPA and Applicable Laws. For security purposes, We could collect some personal data related to your
					browser window to confirm that you are a human and not a bot. In that event, We will inform You
					about the tool/s used for that purpose and refer You to the third party’s{' '}
					<a href="/privacy-policy" className="underline">
						Privacy Policy
					</a>{' '}
					and{' '}
					<a href="/terms-and-conditions" className="underline">
						Terms of Service
					</a>
					.
				</p>
				<div>
					<p>
						4.2 If You wish to use the Services offered by this Website/App, be aware We do not maintain
						user accounts and do not collect and store any personal data (such your name or “IP” address) in
						connection with your use of the Services. We collect only:
					</p>
					<ol className="flex flex-col gap-2 pl-12 py-3 [&>li]:pl-2 [counter-reset:section-counter] [&>li]:[counter-increment:section-counter] [&>li]:marker:[content:'4.2.'counter(section-counter,decimal)]">
						<li>
							Publicly available blockchain data. When You connect your non-custodial blockchain wallet to
							the Services, We collect and log your publicly-available blockchain address to learn more
							about your use of the Services and to screen your wallet for any prior illicit activity. We
							can screen your wallet using blockchain analytics providers. Note that blockchain addresses
							are publicly available data not created or assigned by Us and, as well as, by themselves,
							are not personally identifying.
						</li>
						<li>
							We may receive information about your wallet address or transactions made through the
							Services from our service providers to comply with our legal obligations and prevent the use
							of our Services in connection with suspicious, fraudulent or illicit activities.
						</li>
					</ol>
				</div>
				<p>
					4.3 When you use this Website/App or the Services offered by this Website/App, We may collect more
					information necessary for the purpose of improving the functions of this Website/App, enhancing your
					experience of using this Website/App and its Services as well as the security thereof, or as is
					required by any court order, any applicable law, administrative regulation or any order of any other
					competent government agency.
				</p>
				<p>
					4.4 If You visit any of the links to third-party Website/Apps as could be listed on this Website/App
					or any link of any of our third-party partners, You shall agree to and comply with the separate and
					independent Privacy Policy and Terms of Use/Conditions of such third-party Websites/Apps. We will
					not bear any liability for the contents and activities of such Websites/Apps or the partners.
				</p>
				<div>
					<p>
						4.5 For the avoidance of doubt, in the event that Republic of Seychelles Data Protection Law
						permits an organisation such as Us to collect, use or disclose your personal data without your
						consent, such permission granted by the law shall continue to apply. If You are in the EU, We
						will process your personal data under the following basis and purposes:
					</p>
					<ol className="flex flex-col gap-2 pl-12 py-3 [&>li]:pl-2 [counter-reset:section-counter] [&>li]:[counter-increment:section-counter] [&>li]:marker:[content:'4.5.'counter(section-counter,decimal)]">
						<li>
							You have given consent to the process to Us or, in case, our service providers for one or
							more specific purposes in order to provide You the Services. Likewise, We may also use the
							information disclosed by You (such as your email address, if it is the case) for the
							purposes described when You provide it to Us (e.g. to interact with Us or answer inquiries
							about processing of your personal data) or use some of the information We collect or access
							to compile aggregate data that helps Us learn more about visitors use the Website/App and
							how your experience can be improved.
						</li>
						<li>
							Processing can be essential for the performance of a contract with You, if it is the case;
						</li>
						<li>Processing can be necessary for compliance with a legal obligation;</li>
						<li>
							Processing can be necessary for the purpose of the legitimate interest pursued by Us or a
							third-party (and your interests and fundamental rights and freedom do not override those
							interests); or
						</li>
						<li>
							Meet our obligations to investigate, inform and assist relevant authorities in relation to
							any potential criminal activities such as fraud, money laundering or terrorist financing;
							and
						</li>
						<li>Any other relevant legislation that requires Us to provide some personal information.</li>
					</ol>
					<p>
						In the event to provide You some Services, and for the purpose of preventing illegitimate use of
						such Services, We could carry out profiling of our users and their activities using automated
						processes. However, any decisions taken based on these profiles and information are taken by
						natural persons.
					</p>
				</div>
			</Section>
		)
	},
	{
		title: '5. Cookies',
		text: (
			<Section>
				<p>
					When You visit the Website or use our App, We can collect information about your access and/or use
					of the Services that We could offer You and our interactions with You through the use of Cookies and
					similar technologies.
				</p>
				<p>
					For more detailed information including what Cookies are and how and why We process such data in
					this manner (including the difference between ‘essential’ and ‘non-essential’ Cookies) please read
					Our detailed{' '}
					<a href="/cookie-policy" className="underline">
						Cookies Notice
					</a>
					.
				</p>
				<p>
					5.1 When You visit the Website/App, We use Google stats via Cookies to record our performance and
					check the effect of online advertising. Cookies are a small amount of data that is sent to your
					browser and stored on your computer hard drive. Only when You use your computer to access to the
					Website/App can the Cookies be sent to your computer hard drive.
				</p>
				<p>
					5.2 Cookies are usually used to record the habits and preferences of visitors in browsing the items
					on the Website/App. The information collected by Cookies is non-registered and collective
					statistical data and does not involve personal data.
				</p>
				<p>
					5.3 Cookies, which enable the Website/App or service provider system to recognize your browser and
					capture and recall information, cannot be used to obtain data on your hard drive, your email
					address, or your personal data. Most browsers are designed to accept Cookies. You can opt to set
					your browser to reject Cookies, or to notify You as soon as possible if You are loaded on Cookies.
					However, if You set your browser to disable Cookies, it is possible that You may not be able to
					launch or use some functions of the Website/App.
				</p>
				<p>
					The Website/App may also feature social media widgets. These social media features are either hosted
					by a third party or directly on the Website. When using these widgets, or our respective pages on
					these provider's platforms, We encourage You to read and make reference to their respective privacy
					notices. To find out more, please read our Cookies Notice (hyperlink).
				</p>
			</Section>
		)
	},
	{
		title: '6. Purposes of Information',
		text: (
			<Section>
				<div>
					<p>
						6.1 We will use your information that we collect for the following purposes or in the following
						ways:
					</p>
					<ol className="flex flex-col gap-2 pl-12 py-3 [&>li]:pl-2 [counter-reset:section-counter] [&>li]:[counter-increment:section-counter] [&>li]:marker:[content:'6.1.'counter(section-counter,decimal)]">
						<li>
							to provide You the information displayed on the Website/App and/or, if it is the case, in
							relation to the Services offered through the Website/App;
						</li>
						<li>to identify and confirm your identity when You use the Website/App and contact with Us;</li>
						<li>
							to improve and upgrade the services of the Website/App (your information and feedback
							received by Us can help Us improve the service of the Website/App, so that We can more
							effectively respond to your service requests and support needs);
						</li>
						<li>
							to keep statistics relating to the use of the Website/App and to be used for data analysis
							carried out in cooperation with government agencies, public affairs institutions;
						</li>
						<li>
							to personalize your experience (your information will help Us to better respond to your
							personalized needs);
						</li>
						<li>
							due to business changes We may transfer or share data to another entity in the event of a
							merger, acquisition, bankruptcy, dissolution, reorganization, asset or stock sale, or other
							business transaction;
						</li>
						<li>
							to send e-mail regularly (the email address that You provide for the use of the Website/App
							and/or the Services may be used to receive information in addition to newsletters, updates,
							marketing preferences, related products or services information, etc., that We may send to
							You from time to time) if You provide your consent.
						</li>
					</ol>
				</div>
				<div>
					<p>
						6.2 We do not sell, trade, or otherwise transfer information or allow others to collect and use
						information. We may only share your information any other time You provide Us with your consent
						to do so. Such information does not involve the following parties and does not include the
						following information:
					</p>
					<ul className="list-disc pl-10 py-3 [&>li]:pl-2">
						<li>
							Our affiliates, trusted third parties who help Us operate the Website/Apps, manage our
							business, or provide Services to You, provided that such parties agree to keep such
							information confidential;
						</li>
					</ul>
					<p>
						When We believe that information disclosure is appropriate, or it is required by any of the
						applicable laws, regulations, rules or by any order of courts or other competent authorities,
						and is necessary for executing the strategy of the Website/App and ensuring the proper
						functioning of the Website/App, or as may be necessary for the related parties to provide
						services, or for the protection of the rights, property or safety of Us or other persons.
						However, your information will not be provided to other parties for marketing, advertising or
						other purposes.
					</p>
				</div>
			</Section>
		)
	},
	{
		title: '7. Protection of Personal Data',
		text: (
			<Section>
				<div>
					<p>
						7.1 We adopt appropriate physical, electronic, management and technical measures so as to
						protect and safeguard the security of your personal data. We will, to the greatest extent
						possible, ensure that any personal data collected shall be free from being subject to nuisance
						by any third party unrelated to Us. The security measures that We may take include but are not
						limited to:
					</p>
					<ol className="flex flex-col gap-2 pl-12 py-3 [&>li]:pl-2 [counter-reset:section-counter] [&>li]:[counter-increment:section-counter] [&>li]:marker:[content:'7.1.'counter(section-counter,decimal)]">
						<li>
							Physical measures: records of your personal data will be stored in a properly locked place.
						</li>
						<li>
							Electronic measures: the computer data that contain your personal information will be stored
							in computer systems and storage medias that are subject to strict login restrictions.
						</li>
						<li>
							Management measures: only staff members duly authorized by Us can access your personal data,
							and these staff members shall comply with our internal code concerning personal data
							confidentiality.
						</li>
						<li>Technical measures: encryption may be used to convey your personal data.</li>
						<li>Other measures: our network servers are protected by proper 'firewall ‘.</li>
					</ol>
				</div>
				<p>
					7.2 If You are aware of any security flaws in the Website/App, please contact Us immediately so that
					We can take appropriate action as soon as possible.
				</p>
				<p>
					7.3 Despite of the above-mentioned technical and security measures, We cannot guarantee that the
					information transmitted via the Internet is absolutely safe, so We cannot absolutely guarantee that
					the personal data that You provide to Us through will be safe at any time. We will not be held
					liable for any loss or damage arising from or caused by any event that may occur in connection with
					unauthorized access to your personal data, and We shall not be held liable for compensation for such
					loss or damage.
				</p>
			</Section>
		)
	},
	{
		title: '8. Direct Marketing',
		text: (
			<Section>
				<p>
					We only send mail messages, emails and other communications relating to marketing where We are
					authorized to do so at law. If You are in the EU, We will rely on Your consent to do so (especially
					where We use electronic communications). If, at any time, You no longer wish to receive direct
					marketing communications from Us please let Us know by contacting Us at the details below or update
					Your preference on any of our Website(s) or Apps.
				</p>
				<p>
					In the case of direct marketing sent by electronic communications (where We are legally authorized
					to do so) You shall be given an easy way of opting-out (or unsubscribing) from any such
					communications at any time and without costs.
				</p>
				<p>
					Please note that even if You withdraw any consent You may have given Us or if You object to
					receiving such direct marketing material from Us (in those cases where We do not need your consent),
					from time to time We may still need to send You certain important communications from which You
					cannot opt-out.
				</p>
			</Section>
		)
	},
	{
		title: '9. Cross-border Transfers of Personal Data',
		text: (
			<Section>
				<p>
					Our Company is located in the Republic of Seychelles. To comply with EU data protection laws, We
					have measures in place to ensure that your personal data is granted the same level of protection as
					in the EU.
				</p>
				<p>
					The Company may use service providers that operate in other countries, and We may share your
					personal data to providers outside of the European Economic Area (EEA) in order to provide You with
					the Services You requested; We will always ensure a similar degree of protection when transferring
					personal data outside the EEA, using measures such as transferring to countries deemed to hold an
					adequate level of data protection by the European Commission, and/or Standard Contractual Clauses
					issued by the European Commission, and any additional measures as may be required.
				</p>
			</Section>
		)
	},
	{
		title: '10. Third-party service providers',
		text: (
			<Section>
				<p>
					In the event of using Service Providers, We ensure that any data transfers with such Service
					Providers are covered with appropriate controller-processor contracts and safeguards as specified by
					the GDPR. Such contracts include confidentiality, strict processing rules, security safeguards,
					breach notification requirements and provision of assistance to the Company so that any exercise of
					your rights is satisfied.
				</p>
				<p>
					We may combine personal information We receive from You with personal information falling within one
					of the categories identified above that We obtain from other sources as these third-party services.
					Furthermore, we may integrate technologies operated or controlled by other parties into part of the
					use of the Website/App and/or the Services offered or related to. For example, the Services may
					include links that hyperlink to websites, platforms, and other services not operated or controlled
					by Us. Please note that when You interact with these other parties, including when You leave the
					Site, those parties may independently collect information about You or solicit information from You.
					This data may include your username, profile picture, details of last log-in, and other information
					associated with your account on that third-party service that is made available to us based on your
					account settings on that service, such as Google. This data may include your Google username,
					profile picture and other information associated with your Google account on that third-party
					service that is made available to Us based on your account settings on that service. Our use and
					disclosure of information received from Google’s APIs will adhere to the{' '}
					<a className="underline" href="https://developers.google.com/terms/api-services-user-data-policy">
						Google API Services User Data Policy
					</a>
					, including the Limited Use requirements. Third party services also encompass any virtual currency
					account services You link to the Services. This data may include your wallet address and other
					information associated with your account on that third-party service that is made available to Us
					based on your account settings on that service.
				</p>
				<p>A list of our third-party suppliers can be provided upon request.</p>
			</Section>
		)
	},
	{
		title: '11. For how long do we keep your data?',
		text: (
			<Section>
				<p>
					After your last activity or interaction with the Website/App and/or Services offered, We will retain
					certain elements of personal data for a period of up to five (5) years from last activity to meet
					our legal obligations towards, if it is applicable.
				</p>
				<p>
					We will also keep personal data for the purpose of presenting and processing in case of a litigation
					or a legal process which You, the relevant authorities or Us may be party to, due to our provision
					of Services to You. All this information is stored in accordance with this Privacy Policy. All
					personal data shall not be kept for longer than is necessary and, alternatively, any personal data
					can be anonymized so that it is no longer in a form which permits identification of users/data
					subjects.
				</p>
			</Section>
		)
	},
	{
		title: '12. Your Rights',
		text: (
			<Section>
				<p>
					The European Union’s General Data Protection Regulation and other countries’ privacy laws provide
					certain rights for data subjects.
				</p>
				<p>Under the GDPR, You have the right to:</p>
				<ol className="flex flex-col gap-2 list-[lower-latin] pl-10 py-3 [&>li]:pl-2">
					<li>access to the personal information provided by You;</li>
					<li>request rectification of personal data that You consider incorrect;</li>
					<li>request for restriction of processing of data;</li>
					<li>request erasure of data;</li>
					<li>file an objection about processing of your data;</li>
					<li>request to export your data; and</li>
					<li>be informed about automated individual decision-making, including profiling; and</li>
					<li>
						You have the right at all times to object to the processing of your data and to withdraw your
						consent through your account profile privacy settings.
					</li>
				</ol>
				<p>
					Your rights may be exercised in accordance with the Law, which might include restrictions on when
					You can exercise these rights.
				</p>
				<p>
					You can exercise these rights by contacting us via our EU representative at <EmailLink />. You have
					also the right to lodge a complaint with your local Data Protection Authority You may find a list
					with your local Data Protection Authority contact details at{' '}
					<a href="https://edpb.europa.eu/about-edpb/board/members_en" target="_blank" className="underline">
						https://edpb.europa.eu/about-edpb/board/members_en
					</a>
					or through this link{' '}
					<a href="https://www.infocom.sc/" target="_blank" className="underline">
						https://www.infocom.sc/
					</a>
				</p>
			</Section>
		)
	},
	{
		title: '13. Changes to this Privacy Policy',
		text: (
			<p>
				We reserve the right to amend the Privacy Policy from time to time and at any time. We will inform You
				of the modifications made to the Privacy Policy by updating and publishing the effective date of the
				release of new versions hereof and highlighting the amendments. Sometimes, We may issue a notice to
				inform You of the modification made in the Privacy Policy. You shall regularly review the Privacy Policy
				and focus on its modifications, and if You do not agree to such modifications, You shall immediately
				stop accessing this Website/App. When an updated version of this Privacy Policy is released, your
				continued visit to this Website/App shall indicate and show that You agree to the update and agree to
				comply with the updated Privacy Policy. You can request previous versions of this document by sending Us
				an email at <EmailLink />.
			</p>
		)
	},
	{
		title: '14. Communication with Us',
		text: (
			<Section>
				<p>
					14.1 If You have any requests and comments, You can send an email to <EmailLink /> which is the only
					valid and official email through which we communicate with You, so We will not bear any liability
					for your failure to using effective contact information, any act or omission.
				</p>
				<p>
					14.2 We only publish announcements and information on the basis of the valid and effective contact
					information on this Website/App or post announcements on this Website/App; therefore, We shall not
					be held liable for any loss arising from your trust in the information that has not been obtained
					through the above-mentioned means.
				</p>
				<p>
					14.3 If you have any questions regarding our Privacy Policy, You are welcome to contact Us at any
					time.
				</p>
			</Section>
		)
	}
]

const PrivacyPolicy = () => (
	<div>
		<DocumentTemplate
			title="Privacy Policy"
			contentBuckets={[
				{
					className: 'bg-green-10',
					bucketTitle: 'Peppercoin.com Privacy Policy',
					lastUpdated: 'September 12, 2024',
					content: CONTENT
				}
			]}
		/>
	</div>
)

export default PrivacyPolicy
